import VueCookies from 'vue-cookies'

const JSESSION_KEY = 'vue-user.JSESSIONID'

export function getUserSessionId () {
  return VueCookies.get(JSESSION_KEY)
}

export function setUserSessionId (session) {
  return VueCookies.set(JSESSION_KEY, session)
}

export function removeUserSessionId () {
  return VueCookies.remove(JSESSION_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js